var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8649 7.07753L3.33658 33.0009C3.01642 33.5553 2.84702 34.1839 2.84523 34.8242C2.84344 35.4644 3.00932 36.0939 3.32636 36.6502C3.64341 37.2064 4.10058 37.6699 4.65238 37.9946C5.20418 38.3193 5.83138 38.4938 6.47158 38.5009H37.5282C38.1684 38.4938 38.7956 38.3193 39.3474 37.9946C39.8993 37.6699 40.3564 37.2064 40.6735 36.6502C40.9905 36.0939 41.1564 35.4644 41.1546 34.8242C41.1528 34.1839 40.9834 33.5553 40.6632 33.0009L25.1349 7.07753C24.8081 6.53873 24.3479 6.09325 23.7988 5.78408C23.2496 5.47492 22.6301 5.3125 21.9999 5.3125C21.3697 5.3125 20.7502 5.47492 20.2011 5.78408C19.6519 6.09325 19.1917 6.53873 18.8649 7.07753V7.07753Z",
    stroke: "#FF3B30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.5V23.8333",
    stroke: "#FF3B30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 31.166H22.0183",
    stroke: "#FF3B30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/Caution.2dd551f7169e6236d105222bce8f6a9f.svg";
export { ForwardRef as ReactComponent };